import React from 'react';
import HomePage from '../../../../../components/common/HomePage';

export default function DashboardVendor() {
	return <HomePage />;
}
